import { SpookySwapContainer, SpookySwapText } from './spookySwapLink.styles'
import { SpookySwapLogo2, UniSwapLogo } from './SpookySwapLogo'

// Constants
import { SPOOKY_USDC_LINK, UNISWAP_WPOKT_LINK } from 'components/navbar/navbar.constants'


interface LinkProps {
    chain:string
}

export const SpookySwapLink = ({ chain }:LinkProps): React.ReactElement => {

    let text = "Buy USDC";
    let href = SPOOKY_USDC_LINK
    if (chain === "ethereum") {
        text = "Buy WPOKT";
        href = UNISWAP_WPOKT_LINK
    }

  return (
    <SpookySwapContainer href={href} target={'_blank'}>
          <SpookySwapText>{text}</SpookySwapText> {(chain === "ethereum") ? <UniSwapLogo /> : <SpookySwapLogo2 />}
    </SpookySwapContainer>
  )
}
